import "./AuthNavActions.scss";

import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import OrgSwitcher from "@/components/OrgSwitcher/OrgSwitcher";
import { getPagePath, PAGES } from "@/config/pages";
import { Button } from "@/covaltech-react-ui";
import useLogout from "@/hooks/useLogout";
import { isSupportedLanguage } from "@/i18n/routing";
import { useAuthStore } from "@/stores/AuthStore";

const AuthNavActions = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { lang } = useParams<{ lang: string }>();
  const { isAuthenticated, user } = useAuthStore();
  const handleLogout = useLogout();

  const localizedPath = (page: keyof typeof PAGES) =>
    isSupportedLanguage(lang) ? getPagePath(page, lang) : PAGES[page];

  if (!isAuthenticated || !user) {
    const isLoginPage = location.pathname.includes(PAGES.login);

    return (
      <div className="authNavActions">
        {!isLoginPage && (
          <Button
            label={t("auth.login_title")}
            style="line"
            onClick={() => navigate(localizedPath("login"))}
          />
        )}
        <Button
          label={t("auth.register_title")}
          style="blue"
          onClick={() => navigate(localizedPath("register"))}
        />
      </div>
    );
  }

  return (
    <div className="authNavActions">
      <OrgSwitcher mobile />
      <div className="userBadge">
        <span className="label">{t("auth.connected_as")}</span>
        <span className="value">{user.full_name || user.email}</span>
      </div>
      <Button label={t("auth.logout")} style="blue" onClick={handleLogout} />
    </div>
  );
};

export default AuthNavActions;
